module.exports = __webpack_public_path__ + "img/facial_course.2ebcb3f7.png";